<template>
    <div class="">
        <div class="form-group">
            <label>Titel des Blocks</label>
            <input type="text" class="form-control" v-model="config.title" placeholder="Rabattauswirkung">
        </div>

        <fieldset class="border px-3 mb-3">
            <legend class="w-auto">
                <i class="fas fa-info-circle text-muted"
                   style=""
                   data-toggle="tooltip"
                   data-placement="top"
                   :title="$info['rabatt.mode']"></i>
                Direktrabatt
            </legend>

            <div class="form-group">
                <label><b>Modus</b></label>
                <select class="form-control" v-model="config.rabattMode">
                    <option value="auto">Automatisch bestimmen</option>
                    <option value="custom">Manuelle Eingabe</option>
                </select>
            </div>

            <div class="form-group" v-if="config.rabattMode !== 'auto'">
                <label>Direktrabatt</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Prozent</span>
                    </div>
                    <input type="text" class="form-control" placeholder="0" v-model="config.rabattPercent">
                </div>
            </div>

            <div class="form-check my-2">
                <input class="form-check-input" type="checkbox" value="" :id="id('mode-switch')"
                       v-model="config.sellInModeSwitch">
                <label class="form-check-label" :for="id('mode-switch')">
                    <i class="fas fa-info-circle text-muted"
                       style=""
                       data-toggle="tooltip"
                       data-placement="top"
                       :title="$info['sellIn.modeSwitch']"></i>
                    Überweiser in Direktgeschäft
                </label>
            </div>
        </fieldset>

        <fieldset class="border px-3 mb-3">
            <legend class="w-auto">
                Vergleichsrabatte
            </legend>

            <div class="form-group">
                <label>
                    <i class="fas fa-info-circle text-muted"
                       style=""
                       data-toggle="tooltip"
                       data-placement="top"
                       :title="$info['rabatt.ghPercent']"></i>
                    Durchschnittl. GH Kondition
                </label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Prozent</span>
                    </div>
                    <input type="text" class="form-control" placeholder="0" v-model="config.averageGhPercent">
                </div>
            </div>

            <div class="form-group">
                <label>
                    <i class="fas fa-info-circle text-muted"
                       style=""
                       data-toggle="tooltip"
                       data-placement="top"
                       :title="$info['rabatt.comparePercent']"></i>
                    Vergleichsdirektrabatt
                </label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Prozent</span>
                    </div>
                    <input type="text" class="form-control" placeholder="0" v-model="config.comparePercent">
                </div>
            </div>

        </fieldset>

        <div class="form-group mb-0" v-if="selectableVisibleColumns.length">
            <label>Sichtbare Spalten:</label>
            <div class="form-check form-check-inline" v-for="column in selectableVisibleColumns">
                <input class="form-check-input"
                       type="checkbox"
                       :id="id(column.id)"
                       :value="column.id"
                       :checked="!config.hiddenColumns.includes(column.id)"
                       @change="toggleHiddenColumns(column.id, $event)">
                <label class="form-check-label" :for="id(column.id)">
                    {{ column.label }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import blockMixin from "./blockMixin";

export default {
    components: {},
    mixins: [blockMixin],
    props: {

    },
    data() {
        return {
            config: this.dto
        };
    },
    methods: {
        toggleHiddenColumns(columnId, event) {
            if (event.target.checked) {
                this.config.hiddenColumns = this.config.hiddenColumns.filter(id => id !== columnId);
            } else {
                this.config.hiddenColumns.push(columnId);
            }
        }
    },
    computed: {
        selectableVisibleColumns() {
            return [
                {id: 'belege', label: 'Aufträge'},
            ];
        },
    }
}
</script>
